import type { Selections } from './domain';

/** Public customers use takeaway; staff can retain their own-cup choice. */
export function selectionsForChannel(channel: string, selections: Selections): Selections {
  return { ...selections, packaging: channel === 'employee' ? selections.packaging : 'takeaway' };
}
